import {FreeDeliverySection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/basket_mov.types';
import {SizeSelection_Size} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {AddItemResponseStatus_Success_Section} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/add_item_status.types';
import {useOpenedStateManager} from '@aboutyou/opened-state-manager';
import React, {ComponentType, FC, useState} from 'react';
import {ProductMiniAdp} from '../../../features/ProductMiniAdp/ProductMiniAdp';
import {AddToBasketPayload} from '../../../features/ProductStream/Tiles/StreamProductTileDeprecated';
import {AddToBasketFlyout} from '../../../features/SizeSelectionFlyout/AddToBasketFlyout';
import {AddToBasketOnSuccessProps} from '../../../features/SizeSelectionFlyout/hooks/useAddToBasket';
import {SizeSelectionOpenedStateKey} from '../../../features/SizeSelectionFlyout/hooks/useSizeSelectionOpenedState';
import {ComplementaryRecommendationProps} from '../ComplementaryRecommendation/ComplementaryRecommendation';
import {RecommendationsProp} from '../Recommendations/Recommendations';
import {useDeliveriesSection} from '../hooks/useGetBasketPageSection';

export const RecommendationWrapper: FC<{
  addToBasketMethod?: 'flyout' | 'miniAdp';
  smallerPaddings?: boolean;
  showNavigation?: boolean;
  isSmallFormat?: boolean;
  ViewComponent: ComponentType<
    ComplementaryRecommendationProps | RecommendationsProp
  >;
  name?: string;
  onAddToBasketSuccess?: (props: AddToBasketOnSuccessProps) => void;
}> = ({
  addToBasketMethod,
  smallerPaddings,
  ViewComponent,
  name,
  showNavigation,
  onAddToBasketSuccess,
  isSmallFormat,
}) => {
  const {isOpen, cancel, open} = useOpenedStateManager(
    `A2B_FROM_RECOLANE_${name || addToBasketMethod}`,
  );

  const {refetch: refetchBasketSection} = useDeliveriesSection();

  const [selectedSize, setSelectedSize] = useState<
    SizeSelection_Size | undefined
  >(undefined);
  const [selectedProductTile, setSelectedProductTile] = useState<
    AddToBasketPayload | undefined
  >(undefined);

  const onClickAddToBasket = (productTile: AddToBasketPayload | undefined) => {
    setSelectedSize(undefined);
    setSelectedProductTile(productTile);
    return open();
  };

  const handleScrollToTop = () => {
    if (typeof window !== 'undefined') {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  };

  const onA2BSuccessHandler = async ({
    freeDeliverySection,
    statusSuccessSections,
  }: {
    freeDeliverySection?: FreeDeliverySection;
    statusSuccessSections: AddItemResponseStatus_Success_Section[];
  }) => {
    setSelectedProductTile(undefined);
    await refetchBasketSection();
    onAddToBasketSuccess?.({freeDeliverySection, statusSuccessSections});
    handleScrollToTop();
  };

  return (
    <>
      <ViewComponent
        onClickAddToBasket={onClickAddToBasket}
        smallerPaddings={smallerPaddings}
        showNavigation={showNavigation}
        isSmallFormat={isSmallFormat}
      />

      {!!selectedProductTile && addToBasketMethod === 'flyout' && (
        <AddToBasketFlyout
          isOpen={isOpen}
          product={selectedProductTile.product}
          withSuccessToast
          withErrorToast
          onSuccess={onA2BSuccessHandler}
          onError={handleScrollToTop}
          onClose={() => cancel()}
          onCaptchaClose={() => {
            setSelectedProductTile(undefined);
          }}
        />
      )}
      {!!selectedProductTile && addToBasketMethod === 'miniAdp' && (
        <ProductMiniAdp
          close={cancel}
          isOpen={isOpen}
          productId={selectedProductTile.product.id}
          selectedSize={selectedSize}
          setSelectedSize={setSelectedSize}
          onSuccess={onA2BSuccessHandler}
          reductions={selectedProductTile.price?.reductions}
          sizeSelectionStateManagerKey={
            SizeSelectionOpenedStateKey.MAIN_SIZE_SELECTION
          }
          showToastMessage
        />
      )}
    </>
  );
};
